import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/login/login'
import Formal from '@/page/customer/formal' // 正式客户
import Register from '@/page/customer/register' // 注册客户
import Trial from '@/page/customer/trial' // 试用客户
import TreeTrial from '@/page/customer/freeTrial' // 免审设置

// 业务管理
import Additional from '@/page/business/additional' // 增购
import Reduction from '@/page/business/reduction' // 增购
import Renewal from '@/page/business/renewal' // 续费
import InviteCode from '@/page/business/inviteCode' // 邀请码
import Strategy from '@/page/business/strategy' // 收费策略
import Component from '@/page/business/component' // 组件管理
import ThirdParty from '@/page/business/third-party' // 第三方对照表
import RenewOrder from '@/page/business/renewOrder' // 第三方对照表

import PublishedApply from '@/page/application/published-apply' // 已发布应用
import AuthstrApply from '@/page/application/authstr-apply' // 待发布应用
import HotApply from '@/page/application/hot-apply' // 热门应用
import ChargeBill from '@/page/application/charge-bill' // 收费信息
import ApplyType from '@/page/application/apply-type' // 收费信息
import ApplyDetail from '@/page/application/apply-detail' //  应用详情
import Authorization from '@/page/application/authorization' //  应用详情

import Account from '@/page/platform/account' //  账户管理
import PlatLog from '@/page/platform/plat-log' //  操作日志
import Password from '@/page/platform/password' //  修改密码
import Role from '@/page/platform/role' //  角色权限

import NewsManage from '@/page/news/news-manage' // 新闻管理
import newsSort from '@/page/news/news-sort' // 新闻分类

import helpDocument from '@/page/help/help-document' // 帮助文档
import vedioTeach from '@/page/help/vedio-teach' // 视频教程
import caseExplain from '@/page/help/case-explain' // 案例详解
import FAQ from '@/page/help/FAQ' // 常见问题
import updateLog from '@/page/help/update-log' // 更新日志

import Android from '@/page/appversion/Android' // APP版本

import LocalMonitor from '@/page/monitor/local-monitor' // 本地监测
import OperationManage from '@/page/monitor/operation-manage' // 运营管理

import PlatformMessage from '@/page/version/platform-message' // 本地监测

import Business from '@/page/program/business' // 名片小程序用户表

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/formal',
      name: 'Formal',
      component: Formal
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/trial',
      name: 'Trial',
      component: Trial
    },
    {
      path: '/freeTrial',
      name: 'TreeTrial',
      component: TreeTrial
    },
    {
      path: '/additional',
      name: 'Additional',
      component: Additional
    },
    {
      path: '/reduction',
      name: 'Reduction',
      component: Reduction
    },
    {
      path: '/renewal',
      name: 'Renewal',
      component: Renewal
    },
    {
      path: '/InviteCode',
      name: 'InviteCode',
      component: InviteCode
    },
    {
      path: '/strategy',
      name: 'Strategy',
      component: Strategy
    },
    {
      path: '/component',
      name: 'Component',
      component: Component
    },
    {
      path: '/thirdParty',
      name: 'ThirdParty',
      component: ThirdParty
    },
    {
      path: '/renewOrder',
      name: 'RenewOrder',
      component: RenewOrder
    },
    {
      path: '/publishedApply',
      name: 'PublishedApply',
      component: PublishedApply
    },
    {
      path: '/authstrApply',
      name: 'AuthstrApply',
      component: AuthstrApply
    },
    {
      path: '/hotApply',
      name: 'HotApply',
      component: HotApply
    },
    {
      path: '/chargeBill',
      name: 'ChargeBill',
      component: ChargeBill
    },
    {
      path: '/applyDetail',
      name: 'ApplyDetail',
      component: ApplyDetail
    },
    {
      path: '/authorization',
      name: 'Authorization',
      component: Authorization
    },
    {
      path: '/applyType',
      name: 'ApplyType',
      component: ApplyType
    },
    {
      path: '/news-manage',
      name: 'NewsManage',
      component: NewsManage
    },
    {
      path: '/news-sort',
      name: 'newsSort',
      component: newsSort
    },
    {
      path: '/help-document',
      name: 'helpDocument',
      component: helpDocument
    },
    {
      path: '/vedio-teach',
      name: 'vedioTeach',
      component: vedioTeach
    },
    {
      path: '/case-explain',
      name: 'caseExplain',
      component: caseExplain
    },
    {
      path: '/FAQ',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/update-log',
      name: 'updateLog',
      component: updateLog
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/platLog',
      name: 'PlatLog',
      component: PlatLog
    },
    {
      path: '/password',
      name: 'Password',
      component: Password
    },
    {
      path: '/role',
      name: 'Role',
      component: Role
    },
    {
      path: '/Android',
      name: 'Android',
      component: Android
    },
    {
      path: '/localMonitor',
      name: 'LocalMonitor',
      component: LocalMonitor
    },
    {
      path: '/operationManage',
      name: 'OperationManage',
      component: OperationManage
    },
    {
      path: '/platformMessage',
      name: 'PlatformMessage',
      component: PlatformMessage
    },
    {
      path: '/business',
      name: 'Business',
      component: Business
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js